import React, { memo } from "react";
import { FormControl, FormErrorMessage, FormLabel, Skeleton } from "@chakra-ui/react";
import { Controller } from "react-hook-form";
import { ReactSelectWithChakraStyle } from "../../atoms/ReactSelectWithChakraStyle";
import { SelectOption, NoOptionsMessageProps } from "../../../types/select";
import { useFetchPlans } from "../../../hooks/useFetchPlans";

type PlanSelectorProps = {
    control: any;
    errors: any;
};

export const PlanSelector: React.FC<PlanSelectorProps> = memo(({ control, errors }) => {
    const { plans, isLoading } = useFetchPlans();

    const options: SelectOption[] = (plans || []).map(plan => ({
        label: plan.name,
        value: plan.id,
    }));

    const planError = errors["plan"]?.message;

    if (isLoading) return <Skeleton height="45px" />;

    return (
        <FormControl isInvalid={!!planError} isRequired w="100%">
            <FormLabel>プラン</FormLabel>
            <Controller
                name="restaurant.plan"
                control={control}
                render={({ field }) => (
                    <ReactSelectWithChakraStyle<SelectOption>
                        noOptionsMessage={({ inputValue }: NoOptionsMessageProps) =>
                            !inputValue && options.length === 0 ? "プランが存在しません" : "一致するプランが見つかりません"
                        }
                        placeholder="選択"
                        options={options}
                        value={options.find((opt) => opt.value === field.value)}
                        onChange={(option: SelectOption | null) => field.onChange(option?.value)}
                    />
                )}
            />
            <FormErrorMessage>{planError}</FormErrorMessage>
        </FormControl>
    );
});